<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-5'
    ]"
    alt="power by logo"
    src="@/assets/image/powered-by-swipe-light.svg"
  />
</template>